'use strict';

module.exports = function (column) {

  var c = this.sortable(column) ? 'VueTables__sortable ' : '';

  c += this.columnClass(column);

  return c;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/sortable-class.js